import { LocationsType } from '../types';

/**
 * A list of all available top locations.
 */
export const TOP_LOCATIONS: (LocationsType | undefined)[] = [
    'top-left',
    'top-center',
    'top-right'
];

/**
 * A list of all available top locations.
 */
export const CENTER_LOCATIONS: (LocationsType | undefined)[]  = [
    'top-center',
    'bottom-center'
];

/**
 * The base styles for the toasts' tray.
 */
export const BASE_STYLE = {
    listStyle: 'none'
};
